import React from "react";

import TableCell from "@material-ui/core/TableCell";
import TableSortLabel from "@material-ui/core/TableSortLabel";

class Heading extends React.Component {
  handleSort(orderBy, order) {
    const onSortChange = this.props.onSortChange || null;
    if (onSortChange) {
      onSortChange({ orderBy, order, page: 0 });
    }
  }

  render() {
    const { column, orderBy, order, hasSort } = this.props;

    const isActive = orderBy === column.key;
    const direction = orderBy === column.key ? order : "asc";
    const invertedDirection = isActive
      ? direction === "asc"
        ? "desc"
        : "asc"
      : "asc";

    return (
      <TableCell
        key={column.key}
        sortDirection={orderBy === column.key ? order : false}
      >
        <TableSortLabel
          active={isActive}
          disabled={!hasSort}
          direction={orderBy === column.key ? order : "asc"}
          onClick={() => this.handleSort(column.key, invertedDirection)}
        >
          {column.name}
        </TableSortLabel>
      </TableCell>
    );
  }
}

export default Heading;
